import React from "react";
import * as Animate from "react-reveal";
import { ArrowUpRight } from "../../../components/svgs";

const options = [
  [
    "01",
    "Open cohort sponsorship",
    "Sponsor selected employees into a cohort alongside professionals from other organizations.",
  ],
  [
    "02",
    "Private corporate cohort",
    "Create a dedicated cohort shaped around your company’s priorities and industry.",
  ],
  [
    "03",
    "Customized talent program",
    "Adapt the experience to an internal leadership or business-acumen framework.",
  ],
];

const MBACorporateSection = () => {
  return (
    <section className="bg-hire-tint-yellow py-16 md:py-24 lg:py-28 px-4">
      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-mba-corporate gap-10 lg:gap-20">
        <Animate.Fade bottom>
          <div>
            <p className="flex items-center gap-3 font-poppins text-primary text-sm font-extrabold tracking-widest uppercase mb-5">
              <span className="w-8 h-0.5 bg-secondary inline-block flex-shrink-0"></span>
              For organizations
            </p>
            <h2 className="font-poppins text-primary font-bold tracking-tight text-3xl md:text-4xl leading-tight mb-5">
              Develop high-potential employees into future-ready leaders.
            </h2>
            <p className="font-poppins text-gray text-sm leading-loose max-w-md mb-7">
              Help strong employees connect daily work to business priorities,
              lead cross-functional projects and use data, AI and financial
              logic with greater confidence.
            </p>
            <a
              href="mailto:business@utiva.co"
              className="text-white bg-primary custom-btn custom-btn-with-shadow-primary px-7 py-4 text-center rounded-xl inline-flex items-center gap-3 font-poppins font-bold text-sm focus:outline-none"
            >
              Contact Utiva Business{" "}
              <span aria-hidden="true">
                <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
              </span>
            </a>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="border-t border-[#eadba9]">
            {options.map(([number, title, copy]) => (
              <article
                key={number}
                className="grid grid-cols-mba-list-48 gap-4 py-6 border-b border-[#eadba9]"
              >
                <span className="font-poppins text-secondary font-extrabold text-sm">
                  {number}
                </span>
                <div>
                  <h3 className="font-poppins text-primary font-semibold text-base mb-1.5">
                    {title}
                  </h3>
                  <p className="font-poppins text-gray text-sm leading-relaxed m-0">
                    {copy}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default MBACorporateSection;
